export const USAmperage = [10, 15, 20, 30, 50, 100];
export const EUAmperage = [3, 6, 10, 13, 16, 25, 32, 63];
export const EVCSAmperage = [6, 8, 10, 14, 16, 24, 32];
export const TIMER_LIMIT = 5;

export const BATTERY_STATES = {
    BATTERY_LIFE_ACTIVE: 'battery_life_active',
    BATTERY_SOC_GUARD_ACTIVE: 'battery_soc_guard_active',
    BATTERY_KEEP_CHARGED: 'battery_keep_charged',
};

export const SYSTEM_VALUES = {
    OPTIMIZED_WITH_BATTERY_LIFE: 1,
    OPTIMIZED_WITHOUT_BATTERY_LIFE: 10,
    KEEP_BATTERIES: 9,
    DISABLED: 0,
};

export const HUB4_OPTIONS = {
    DISABLED: 3,
    PHASE_SPLIT: 2,
    PHASE_COMPENSATION: 1,
};

export const AC_INPUT_TYPE = {
    0: 'not_available',
    1: 'grid',
    2: 'generator',
    3: 'shore',
};

export const EVCS_MODES = {
    AUTO: 1,
    MANUAL: 0,
    SCHEDULED: 2,
};

export const DYNAMIC_ESS_OPTIONS = {
    AUTO: 1,
    EXTERNAL: 4,
    OFF: 0,
};

export const AC_SYSTEM_ESS_MODE_OPTIONS = {
    OPTIMIZED_WITH_BATTERY_LIFE: 0,
    OPTIMIZED_WITHOUT_BATTERY_LIFE: 1,
    KEEP_BATTERIES: 2,
    EXTERNAL_CONTROL: 3,
};

export const getSuggestedAmperageValuesList = productId => {
    const result = productId & 0xff00;
    if (result === 0x1900 || result === 0x2600) {
        return EUAmperage;
    } else if (result === 0x2000 || result === 0x2700) {
        return USAmperage;
    }
    return EUAmperage;
};

export const getEssSubscriptions = () => [
    {
        dbusPath: '/CustomName',
        varName: 'customName',
    },
    {
        dbusPath: '/ProductName',
        varName: 'productName',
    },
    {
        dbusPath: '/Settings/CGwacs/BatteryLife/State',
        varName: 'batteryLifeState',
        dbusServiceType: 'settings',
    },
    {
        dbusPath: '/Settings/CGwacs/BatteryLife/SocLimit',
        varName: 'socLimit',
        dbusServiceType: 'settings',
    },
    {
        dbusPath: '/Settings/CGwacs/Hub4Mode',
        varName: 'hub4Mode',
        dbusServiceType: 'settings',
    },
    {
        dbusPath: '/Settings/CGwacs/BatteryLife/MinimumSocLimit',
        varName: 'minSoc',
        dbusServiceType: 'settings',
    },
    {
        dbusPath: '/Settings/DynamicEss/Mode',
        varName: 'essMode',
        dbusServiceType: 'settings',
    },
    {
        dbusPath: '/Settings/DynamicEss/MinSoc',
        varName: 'essSoc',
        dbusServiceType: 'settings',
    },
];

export const getAcSystemEssSubscriptions = () => [
    {
        dbusPath: '/CustomName',
        varName: 'customName',
    },
    {
        dbusPath: '/ProductName',
        varName: 'productName',
    },
    {
        dbusPath: '/Settings/Ess/Mode',
        varName: 'acSystemEssMode',
    },
    {
        dbusPath: '/Settings/Ess/MinimumSocLimit',
        varName: 'minSoc',
    },
    {
        dbusPath: '/Ess/ActiveSocLimit',
        varName: 'socLimit',
    },
    {
        dbusPath: '/Settings/DynamicEss/Mode',
        varName: 'dessMode',
        dbusServiceType: 'settings',
    },
];

export const getInverterSubscriptions = () => [
    {
        dbusPath: '/Mode',
        varName: 'inverterMode',
    },
    {
        dbusPath: '/State',
        varName: 'inverterState',
    },
    {
        dbusPath: '/ModeIsAdjustable',
        varName: 'inverterAdjustable',
    },
    {
        dbusPath: '/Ac/ActiveIn/ActiveInput',
        varName: 'activeInput',
    },
    {
        dbusPath: '/ProductId',
        varName: 'productId',
    },
    {
        dbusPath: '/CustomName',
        varName: 'customName',
    },
    {
        dbusPath: '/ProductName',
        varName: 'productName',
    },
    {
        dbusPath: '/Settings/SystemSetup/AcInput1',
        varName: 'acInputs',
        varIndx: 0,
    },
    {
        dbusPath: '/Settings/SystemSetup/AcInput2',
        varName: 'acInputs',
        varIndx: 1,
    },
    {
        dbusPath: '/Ac/In/1/CurrentLimit',
        varName: 'acLimits',
        varIndx: 0,
    },
    {
        dbusPath: '/Ac/In/2/CurrentLimit',
        varName: 'acLimits',
        varIndx: 1,
    },
    {
        dbusPath: '/Ac/In/1/CurrentLimitIsAdjustable',
        varName: 'acLimitAdjustable',
        varIndx: 0,
    },
    {
        dbusPath: '/Ac/In/2/CurrentLimitIsAdjustable',
        varName: 'acLimitAdjustable',
        varIndx: 1,
    },
    {
        dbusPath: '/Dc/0/PreferRenewableEnergy',
        varName: 'preferRenewable',
    },
];

export const INVERTER_RS_VARS = {
    INVERTER_MODE: 'inverterMode',
    CUSTOM_NAME: 'customName',
    PRODUCT_NAME: 'productName',
};

export const getInverterRsSubscriptions = () => [
    {
        dbusPath: '/Mode',
        varName: INVERTER_RS_VARS.INVERTER_MODE,
    },
    {
        dbusPath: '/CustomName',
        varName: INVERTER_RS_VARS.CUSTOM_NAME,
    },
    {
        dbusPath: '/ProductName',
        varName: INVERTER_RS_VARS.PRODUCT_NAME,
    },
];

export const MULTI_RS_VARS = {
    MULTI_MODE: 'multiMode',
    CUSTOM_NAME: 'customName',
    PRODUCT_NAME: 'productName',
};

export const getMultiRsSubscriptions = () => [
    {
        dbusPath: '/Mode',
        varName: MULTI_RS_VARS.MULTI_MODE,
    },
    {
        dbusPath: '/CustomName',
        varName: MULTI_RS_VARS.CUSTOM_NAME,
    },
    {
        dbusPath: '/ProductName',
        varName: MULTI_RS_VARS.PRODUCT_NAME,
    },
];

export const getAcSystemSubscriptions = () => [
    {
        dbusPath: '/Mode',
        varName: 'inverterMode',
    },
    {
        dbusPath: '/ProductId',
        varName: 'productId',
    },
    {
        dbusPath: '/CustomName',
        varName: 'customName',
    },
    {
        dbusPath: '/ProductName',
        varName: 'productName',
    },
    // Only AC Input 1 used for now in AC System
    {
        dbusPath: '/Ac/In/1/CurrentLimit',
        varName: 'acLimits',
        varIndx: 0,
    },
    {
        dbusPath: '/Ac/In/2/CurrentLimit',
        varName: 'acLimits',
        varIndx: 1,
    },
    {
        dbusPath: '/Ac/In/1/CurrentLimitIsAdjustable',
        varName: 'acLimitAdjustable',
        varIndx: 0,
    },
    {
        dbusPath: '/Ac/In/2/CurrentLimitIsAdjustable',
        varName: 'acLimitAdjustable',
        varIndx: 1,
    },
];

export const getRelaysSubscriptions = () => [
    {
        dbusPath: '/Relay/0/State',
        varName: 'relays',
        varIndx: 0,
        dbusServiceType: 'system',
    },
    {
        dbusPath: '/Relay/1/State',
        varName: 'relays',
        varIndx: 1,
        dbusServiceType: 'system',
    },
    {
        dbusPath: '/Settings/Relay/Function',
        varName: 'relayFunction',
        varIndx: 0,
        dbusServiceType: 'settings',
    },
    {
        dbusPath: '/Settings/Relay/1/Function',
        varName: 'relayFunction',
        varIndx: 1,
        dbusServiceType: 'settings',
    },
];

export const getChargingStationSubscriptions = () => [
    {
        dbusPath: '/CustomName',
        varName: 'customName',
    },
    {
        dbusPath: '/SetCurrent',
        varName: 'current',
    },
    {
        dbusPath: '/Mode',
        varName: 'mode',
    },
    {
        dbusPath: '/StartStop',
        varName: 'startStop',
    },
];

export const getGeneratorsSubscriptions = () => [
    {
        dbusPath: '/State',
        varName: 'state',
    },
    {
        dbusPath: '/Runtime',
        varName: 'runtime',
    },
    {
        dbusPath: '/ManualStartTimer',
        varName: 'manualTimer',
    },
    {
        dbusPath: '/ManualStart',
        varName: 'manualStart',
    },
    {
        dbusPath: '/RunningByConditionCode',
        varName: 'runningByConditionCode',
    },
    {
        dbusPath: '/AutoStartEnabled',
        varName: 'autoStartEnabled',
    },
    {
        dbusPath: '/ServiceCounter',
        varName: 'serviceCounter',
    },
    {
        dbusPath: '/ServiceInterval',
        varName: 'serviceInterval',
    },
];

export function subscribeToInfo({ subscriptions = null } = {}) {
    const toSubscribe = subscriptions || this.SUBSCRIPTIONS;
    toSubscribe.forEach(subscription => {
        this.MQTTRealtimeService.subscribeToPath({
            ...this.mqttPathObj,
            ...subscription,
            callbackIdentifier:
                subscription.callbackIdentifier ||
                this.getCallbackIdentifier(subscription.varName + (subscription.varIndx || '')),
            callback: ({ payload }) => {
                if (subscription.varIndx !== undefined) {
                    this.$set(this[subscription.varName], subscription.varIndx, payload.value);
                } else {
                    this[subscription.varName] = payload.value;
                }
            },
        });
    });
}

export function unsubscribeFromInfo(subscriptions = this.SUBSCRIPTIONS) {
    subscriptions.forEach(subscription => {
        this.MQTTRealtimeService.unsubScribeFromPath({
            ...this.mqttPathObj,
            ...subscription,
            callbackIdentifier: this.getCallbackIdentifier(
                subscription.varName + (subscription.varIndx || ''),
            ),
        });
    });
}

export function publishToPath(subscription, payload, oldValue) {
    const path = {
        ...this.mqttPathObj,
        prefix: 'W/',
        ...subscription,
    };
    this.MQTTRealtimeService.publishToPath(path, payload);
    this.ApiService.logRemoteControl(this.installationId, {
        ...path,
        value: payload.value,
        oldValue: oldValue,
    });
}

export const reloadIosEvcsWidgets = () => {
    if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.reloadEvcs
    ) {
        window.webkit.messageHandlers.reloadEvcs.postMessage({});
    }
};

export const reloadIosGeneratorWidgets = () => {
    if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.reloadGenerators
    ) {
        window.webkit.messageHandlers.reloadGenerators.postMessage({});
    }
};

export const DEVICE_INSTANCES_PROPS = [
    {
        varName: 'inverterInstances',
        dbusServiceType: 'vebus',
        callbackIdentifier: 'deviceControlsInverters',
    },
    {
        varName: 'inverterRsInstances',
        dbusServiceType: 'inverter',
        callbackIdentifier: 'deviceControlsInvertersRs',
    },
    {
        varName: 'essInstances',
        dbusServiceType: 'hub4',
        callbackIdentifier: 'deviceControlsEss',
    },
    {
        varName: 'systemInstances',
        dbusServiceType: 'system',
        callbackIdentifier: 'deviceControlsSystem',
    },
    {
        varName: 'chargingStationInstances',
        dbusServiceType: 'evcharger',
        callbackIdentifier: 'deviceControlsChargingStations',
    },
    {
        varName: 'generatorInstances',
        callbackIdentifier: 'deviceControlsGenerators',
        dbusServiceType: 'generator',
    },
    {
        varName: 'multiRsInstances',
        dbusServiceType: 'multi',
        callbackIdentifier: 'deviceControlsMultis',
    },
    {
        varName: 'acSystemInstances',
        dbusServiceType: 'acsystem',
        callbackIdentifier: 'deviceControlsAcSystem',
    },
    {
        varName: 'acSystemEssInstances',
        dbusServiceType: 'acsystem',
        callbackIdentifier: 'deviceControlsAcSystemEss',
    },
];
